import { useState, useEffect } from 'react';
import { getAccountInfo } from '@fff-web/fff-utilities';

const useUserShippingAddress = () => {
  const [shippingAddress, setShippingAddress] = useState(null);

  useEffect(() => {
    getAccountInfo('dev').then(({ shippingAddress: sa }) => {
      setShippingAddress(sa);
    });
  }, []);

  return shippingAddress;
};

export default useUserShippingAddress;
